// Import react elements
import { useContext } from "react";

// Import strich api calls
import { updateAccountSubscription } from "api/APIStrichCalls";

// Import context function
import { AuthContext } from "global/context/AuthContext";
import { UserContext } from "global/context/UserContext";

// Import hooks
import { useToast } from "global/hooks/useToast";

// Import components
import { GridItem } from "global/components/Grid";
import SubscriptionSummaryPanel from "./SubscriptionSummaryPanel";



const SubscriptionLevel = ({userData, setUserData}) => {

    // Get the authentication token from the AuthContext
    const { token } = useContext(AuthContext);

    // Get subscription levels and packages
    const { subscriptionLevels, subscriptionPackages } = useContext(UserContext);

    // Define toast options
    const { toastSuccess, toastError } = useToast();



    // Function to toggle the auto renew setting
    const handleToggleAutoRenew = async (nextCheckedValue) => {

        // Make the payload
        const payload = {
            "id": userData.active_subscription.id,
            "auto_renew": nextCheckedValue ? "Y" : "N",
        };
        
        // Make the call
        const response = await updateAccountSubscription(token, payload);

        if (response.success) {

            // Update the user account data so the UI updates immediately
            setUserData((prev) => {

                const updatedSubscription = prev.active_subscription;

                return {
                    ...prev,
                    active_subscription: {
                        ...updatedSubscription,
                        auto_renew: nextCheckedValue ? "Y" : "N",
                    },
                };

            });
            
            // Toast success
            toastSuccess({ title: "Success", message: "Subscription updated." });

        } else {

            // Toast error
            toastError({ title: "Error", message: "Could not update subscription: " + response.error, autoCloseMs: 6000 });

        }

    };



    return (

        <GridItem>

            <SubscriptionSummaryPanel
                userData={userData}
                subscriptionLevels={subscriptionLevels}
                subscriptionPackages={subscriptionPackages}
                showStatus={true}
                showAutoRenew={true}
                onToggleAutoRenew={handleToggleAutoRenew}
                buttonTitle="Upgrade"
                buttonSize="l"
            />

        </GridItem>

    );

};

export default SubscriptionLevel;